var _ = require("underscore");

var getTags = function(selectedIds, resources, separator) {
    if (!selectedIds || selectedIds.length === 0 || resources.length === 0) {
        return "";
    }

    var result = selectedIds.split(separator)
                            .filter(function(id) {
                                return id && id.length > 0;
                            })
                            .map(function(id) {
                                var resource = resources.filter(function(r) {
                                   return r.Id === id;
                                });
                                return resource.length === 0 ? null : resource[0].Name;
                            })
                            .filter(function(name) {
                                return name !== null;
                            });

    return result.join(",");
};

module.exports = getTags;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/services/getTags.js
// module id = 6776482078235094
// module chunks = 1